import { Component } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { CurrentUserService } from '@services/current-user.service';
import { OrganizationsService } from '@services/organizations.service';
import { StorefrontsService } from '@services/storefronts.service';
import { distinctUntilChanged, filter, map, startWith } from 'rxjs/operators';

@Component({
  selector: 'vnm-topbar',
  templateUrl: './topbar.component.html',
  styleUrls: ['./topbar.component.scss']
})
export class TopbarComponent {
  user$ = this.currentUser.user$;
  isTrainingManager$ = this.user$.pipe(map((user) => user.is('training_manager')));

  showOrgSelect$ = this.router.events.pipe(
    filter((event) => event instanceof NavigationEnd),
    distinctUntilChanged(),
    startWith(false),
    map(() => {
      let currentRoute = this.route.root;
      while (currentRoute.firstChild) {
        if (currentRoute.routeConfig?.data?.selectOrg) {
          return true;
        }
        currentRoute = currentRoute.firstChild;
      }

      return false;
    })
  );

  organizationsForInstructor$ = this.organizationsService.listForInstructor$;
  showOrgInstructorSelect$ = this.router.events.pipe(
    filter((event) => event instanceof NavigationEnd),
    distinctUntilChanged(),
    startWith(false),
    map(() => {
      let currentRoute = this.route.root;
      while (currentRoute.firstChild) {
        if (currentRoute.routeConfig?.data?.selectOrgInstructor) {
          return true;
        }
        currentRoute = currentRoute.firstChild;
      }

      return false;
    })
  );

  showShoppingCartButton$ = this.storefrontsService.current$.pipe(map((storefront) => storefront.can.createOrder));

  constructor(
    private currentUser: CurrentUserService,
    private storefrontsService: StorefrontsService,
    private router: Router,
    private route: ActivatedRoute,
    private organizationsService: OrganizationsService
  ) {}
}
